import React from 'react';
import { useTranslation } from 'react-i18next';
import proverLogo from '../../Resources/prover.svg';
import s from './Footer.module.scss';
import Subscribe from './Subscribe.jsx'

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className={s.footer}>
      <div>
        <a href="https://prover.io">
          <img src={proverLogo} alt="Prover" />
        </a>
      </div>
      <div className={s.links}>
        <h5><a href="https://prover.io">prover.io</a></h5>
        <ul>
          <li>
            <a
              href="https://prover.io/#whatisprover"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer_description')}
            </a>
          </li>
          <li>
            <a
              href="https://prover.io/#howitworks-1"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer_hiw')}
            </a>
          </li>
          <li>
            <a
              href="https://prover.io/#typework"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer_use_cases')}
            </a>
          </li>
          <li>
            <a
              href="https://prover.io/#roadmap"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer_road_map')}
            </a>
          </li>
        </ul>
      </div>
      <div className={s.links}>
        <h5><a href="https://product.prover.io">product.prover.io</a></h5>
        <ul>
          <li>
            <a
              href="https://product.prover.io/swype-id"
              target="_blank"
              rel="noopener noreferrer"
            >
              Prover SWYPE ID
            </a>
          </li>
          <li>
            <a
              href="https://product.prover.io/clapperboard"
              target="_blank"
              rel="noopener noreferrer"
            >
              Prover Clapperboard
            </a>
          </li>
          <li>
            <a
              href="https://product.prover.io/fake-detector"
              target="_blank"
              rel="noopener noreferrer"
            >
              Prover Fake detector
            </a>
          </li>
        </ul>
      </div>
      <Subscribe t = {t} />
    </div>
  );
};

export default Footer;
